import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
  OnInit,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { difference } from 'lodash-es';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'aux-investigator-transactions-add-filter',
  templateUrl: './investigator-transactions-add-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvestigatorTransactionsAddFilterComponent implements OnInit {
  readonly originalOptionalFilters = [
    'Patient Group',
    'Protocol Version',
    'Description',
    'Country',
    'Category',
  ];

  @Input() renderedFilters$!: BehaviorSubject<any[]>;

  @Output() selectFilterChange = new EventEmitter<string>();

  isOpen = false;

  optionalFilters = [...this.originalOptionalFilters];

  toggleOpenList = (value: boolean) => {
    this.isOpen = value;
  };

  selectFilter(filterName: string) {
    this.toggleOpenList(false);
    this.selectFilterChange.emit(filterName);
    this.optionalFilters = this.optionalFilters.filter((name) => name !== filterName);
  }

  ngOnInit(): void {
    this.renderedFilters$.pipe(untilDestroyed(this)).subscribe((list) => {
      this.optionalFilters = difference(
        this.originalOptionalFilters,
        list.map(({ label }) => label)
      );
    });
  }
}
